import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

type ErrorModalProps = {
  open: boolean;
  onClose: () => void;
  message?: string | null;
  title?: string | null;
  [x: string]: any;
};

export default function Modal(props: ErrorModalProps) {
  const { t } = useTranslation();
  const { message, title } = props;

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ backgroundColor: "var(--text-primary)", color: "#ffffff" }}>
        {title && title}
      </DialogTitle>
      <DialogContent>
        {message &&
          (message.trim() === "End date should be greater than start date"
            ? t("Start time cannot be greater than end time")
            : t(message))}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          style={{ backgroundColor: "var(--text-primary)", color: "#ffffff" }}
          onClick={props.onClose}
        >
          {t("Ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
